import { useRef, useState, useEffect } from 'react';
import TextBoxControl from "../../../../Controls/TextBoxControl"
import GridControl from "../../../../Controls/GridControl"
import Accordion from 'react-bootstrap/Accordion';
import ShowOwnerResidentialInfo from "../../../../Controls/ShowOwnerResidentialInfo"
import ShowFilesReviewAbstractList from "../../../../Controls/ShowFilesReviewAbstractList"

import {
	GetLocal,
	FetchService,
	Base64Type
} from "../../../../Base/BaseControl";
import { EmployeeSessionCheckFetch } from '../../../../Base/BasePageEmployee';

export default function Index(props) {
	const [getServiceResult, setServiceResult] = useState(false);

	useEffect(() => {
		var inputValue = {
			session: GetLocal('EmployeeSession'),
			requestNumber: GetLocal('RequestNumber')
		};
		EmployeeSessionCheckFetch("Employee/Urbanization/Review/ShowCertificateReview", inputValue, ShowServiceResultSuccess);
	}, []);

	const ShowServiceResultSuccess = (ServiceResult) => {
		ServiceResult.TotalDeclaredAmount = ServiceResult.TotalDeclaredAmount.toLocaleString();
		ServiceResult.TotalCalculatedAmount = ServiceResult.TotalCalculatedAmount.toLocaleString();
		ServiceResult.TotalReceivedAmount = ServiceResult.TotalReceivedAmount.toLocaleString();
		ServiceResult.ExpertPrice = ServiceResult.ExpertPrice.toLocaleString();

		ServiceResult.RegionalPriceAfter = ServiceResult.RegionalPriceAfter.toLocaleString();
		ServiceResult.AreaRepairingSide = ServiceResult.AreaRepairingSide.toLocaleString();

		ServiceResult.RegionalPriceBefor = ServiceResult.RegionalPriceBefor.toLocaleString();
		ServiceResult.RegionalPriceBackBefor = ServiceResult.RegionalPriceBackBefor.toLocaleString();

		ServiceResult.FileChargesInfoList.forEach(item => {
			item.CalculatedAmount = item.CalculatedAmount.toLocaleString();
			item.DeclaredAmount = item.DeclaredAmount.toLocaleString();
			item.ReceivedAmount = item.ReceivedAmount.toLocaleString();
		});

		setServiceResult(ServiceResult);
	}

	return (
		<div>
			<ShowOwnerResidentialInfo Session={GetLocal('EmployeeSession')} />
			<ShowFilesReviewAbstractList />
			{getServiceResult ? <div>
				<table className="table table-bordered table-striped tblbg" cellspacing="0" cellpadding="0" style={{ width: '100%' }}>
					<tbody>
						<tr>
							<td><b class="b1">حق مشرفیت پرداخت شده است:</b> {getServiceResult.IsValueCapturePayment ? 'بله' : 'خیر'} </td>
							<td><b class="b1">حق مشرفیت تعلق می گیرد:</b> {getServiceResult.IsValueCapture ? 'بله' : 'خیر'} </td>
						</tr>
						<tr>
							<td><b class="b1">تاریخ احداث بنا بعد از 70/11/3 میباشد:</b> {getServiceResult.IsBuildingAfterBaseDate ? 'بله' : 'خیر'} </td>
							<td><b class="b1">بر اصلاحی رعایت شده است:</b> {getServiceResult.IsRepairing ? 'بله' : 'خیر'} </td>
						</tr>
						<tr>
							<td colspan="2"><b class="b1">پارامتر های محاسبه عوارض زیر بنا:</b> {getServiceResult.CalculateType ? 'بر اساس سند' : 'بر اساس باقی مانده'} </td>
						</tr>
					</tbody>
				</table>
				<br />
				<GridControl
					data={Object.keys(getServiceResult).length > 0 && getServiceResult.FileChargesInfoList}
					customHeaders={{
						"ChargesTitle": "عنوان عوارض",
						"CalculatedAmount": "مبلغ محاسبه شده",
						"DeclaredAmount": "مبلغ اعلام شده",
						"ReceivedAmount": "مبلغ وصول شده",
						"Formula": "فرمول خام",
						"NumberedFormula": "فرمول عدد گذاری شده"
					}}
					customRenderCell={{
						Formula: (row) => (
							<div dir="ltr" style={{ textAlign: "center" }}>
								{row.Formula}
							</div>
						),
						NumberedFormula: (row) => (
							<div dir="ltr" style={{ textAlign: "center" }}>
								{row.NumberedFormula}
							</div>
						)
					}}
				/>
				<br />
				<table className="table table-bordered table-striped tblbg" cellspacing="0" cellpadding="0" style={{ width: '100%' }}>
					<tbody>
						<tr>
							<td><b class="b1">جمع محاسبه شده:</b> {getServiceResult.TotalCalculatedAmount} </td>
							<td><b class="b1">جمع اعلام شده:</b> {getServiceResult.TotalDeclaredAmount} </td>
							<td><b class="b1">جمع وصول شده:</b> {getServiceResult.TotalReceivedAmount} </td>
						</tr>
					</tbody>
				</table>
				<br />
				<table className="table table-bordered table-striped tblbg" cellspacing="0" cellpadding="0" style={{ width: '100%' }}>
					<tbody>
						<tr>
							<td><b class="b1">عنوان فیلد اول:</b> {getServiceResult.FirstField}</td>
							<td><b class="b1">عنوان فیلد دوم:</b> {getServiceResult.SecondField}</td>
							<td><b class="b1">قیمت کارشناسی:</b> {getServiceResult.ExpertPrice}</td>
						</tr>
					</tbody>
				</table>
				<br />

				<p class="text-primary">قبل از رعایت بر اصلاحی</p>
				<table className="table table-bordered table-striped tblbg" cellspacing="0" cellpadding="0" style={{ width: '100%' }}>
					<tbody>
						<tr>
							<td><b class="b1">مساحت زمین:</b> {getServiceResult.AreaBeforRepairing} </td>
							<td><b class="b1">عمق جبهه:</b> {getServiceResult.DeepBeforRepairing} </td>
							<td><b class="b1">قیمت منطقه ای میانگین است:</b> {getServiceResult.IsPriceBeforAverage ? 'دارد' : 'ندارد'} </td>
						</tr>
						<tr>
							<td><b class="b1">قیمت منطقه ای:</b> {getServiceResult.RegionalPriceBefor} </td>
							<td><b class="b1">قیمت پشت جبهه:</b> {getServiceResult.RegionalPriceBackBefor} </td>
							<td><b class="b1">مساحت پشت جبهه:</b> {getServiceResult.AreaBeforRepairingBack} </td>
						</tr>
					</tbody>
				</table>
				<br />

				<p class="text-primary">بعد از رعایت بر اصلاحی</p>
				<table className="table table-bordered table-striped tblbg" cellspacing="0" cellpadding="0" style={{ width: '100%' }}>
					<tbody>
						<tr>
							<td><b class="b1">مساحت زمین:</b> {getServiceResult.AreaAfterRepairing} </td>
							<td><b class="b1">عمق جبهه:</b> {getServiceResult.DeepAfterRepairing} </td>
							<td><b class="b1">قیمت منطقه ای میانگین است:</b> {getServiceResult.IsPriceAfterAverage ? 'دارد' : 'ندارد'}  </td>
						</tr>
						<tr>
							<td><b class="b1">قیمت منطقه ای:</b> {getServiceResult.RegionalPriceAfter} </td>
							<td><b class="b1">مساحت بر جبهه:</b> {getServiceResult.AreaRepairingSide} </td>
							<td><b class="b1">مساحت پشت جبهه:</b> {getServiceResult.AreaAfterRepairingBack} </td>
						</tr>
					</tbody>
				</table>
				<br />

				<table className="table table-bordered table-striped tblbg" cellspacing="0" cellpadding="0" style={{ width: '100%' }}>
					<tbody>
						<tr>
							<td><b class="b1">توضیحات اعلام عوارض:</b> {getServiceResult.DeclarationDescription}</td>
							<td><b class="b1">توضیحات وصول عوارض:</b> {getServiceResult.ReceiveDescription}</td>
						</tr>
					</tbody>
				</table>
			</div>
				:
				<div className="alert alert-danger text-center">موردی یافت نشد.</div>
			}
		</div>
	);
}
